<template>
  <div v-if="isShow" class="full-page">
    <div>
      说明：<br />
      1.冲突字段会标红，点击你要保留的单元格内容；<br />
      2.姓名不一致时，默认为不同的人；选择保留一位人选时，另一人选手机号会被删除，变为cc；<br />
      3.结果字段为合并结果预览。
    </div>
    <div class="full-body">
      <table v-if="isShow" class="a-table" cellspacing="0">
        <tr>
          <th></th>
          <th v-for="(head, key) in heads" :key="key" :class="{ diffitem: isDiff(head) }">{{ head }}</th>
        </tr>
        <tr>
          <td>新增数据</td>
          <template v-for="(head, key) in heads">
            <td
              v-if="isDiff(head)"
              :key="'new' + key"
              title="点击选择"
              :class="{ diffitem: isDiff(head) }"
              @click="pick(head, newData[head])"
            >
              {{ newData[head] }}
            </td>
            <td v-else>{{ newData[head] }}</td>
          </template>
        </tr>
        <tr>
          <td>系统旧数据</td>
          <template v-for="(head, key) in heads">
            <td
              v-if="isDiff(head)"
              :key="'old' + key"
              title="点击选择"
              :class="{ diffitem: isDiff(head) }"
              @click="pick(head, oldData[head])"
            >
              {{ oldData[head] }}
            </td>
            <td v-else>{{ oldData[head] }}</td>
          </template>
        </tr>
        <tr>
          <td>合并结果预览</td>
          <td v-for="(head, key) in heads" :key="'merge' + key" :class="{ diffitem: isDiff(head) }">
            <span v-if="isDiff(head)" style="color: #ccc">字段冲突,请点击上方选择要保留的数据</span>
            <span v-else>{{ mergedData[head] }}</span>
          </td>
        </tr>
      </table>

      <div style="text-align: right;padding: 10px;">
        <el-button type="primary" size="small" @click="confirmMerge">确定合并</el-button>
      </div>
    </div>
    <div class="fix-middle-actions"><el-button circle size="mini" icon="el-icon-close" @click="close"></el-button></div>
  </div>
</template>
<script>
import { isArrEq, mergeLcs } from '../constant/common-methods.js'

export default {
  data() {
    return {
      isShow: false,
      heads: ['姓名', '手机', '公司'],
      oldId: '',
      oldData: [],
      newData: [],
      mergedData: [],
      onConfirm: function() {},
    }
  },
  methods: {
    show(params) {
      const { oldData, newData, onConfirm } = params
      const tmpOld = {}
      const tmpNew = {}
      const tmpMerged = {}
      for (const field in newData) {
        if (newData.hasOwnProperty(field)) {
          let mergedVal = newData[field]
          if (newData[field] instanceof Array) {
            if (!oldData[field]) oldData[field] = []
            if (!isArrEq(oldData[field], newData[field])) {
              if (!this.heads.includes(field)) {
                this.heads.push(field)
              }
              mergedVal = Array.from(new Set(newData[field].concat(oldData[field])))
            }
          } else if (newData[field] && newData[field] != oldData[field]) {
            if (!this.heads.includes(field)) {
              this.heads.push(field)
            }
            if (oldData[field]) {
              if (field == '旧系统沟通备注') {
                mergedVal = mergeLcs(oldData[field], newData[field])
              } else {
                mergedVal = ''
              }
            }
          }
          if (this.heads.includes(field)) {
            tmpOld[field] = oldData[field]
            tmpNew[field] = newData[field]
            tmpMerged[field] = mergedVal
          }
        }
      }
      this.oldId = oldData._id
      this.oldData = tmpOld
      this.newData = tmpNew
      this.mergedData = tmpMerged
      this.onConfirm = onConfirm || function() {}
      this.isShow = true
    },
    isDiff(head) {
      if (!this.mergedData[head] && this.oldData[head]) return true
      return false
    },
    close() {
      this.isShow = false
    },
    pick(head, val) {
      this.mergedData[head] = val
    },
    async confirmMerge() {
      if (this.oldData['姓名'] != this.newData['姓名']) {
        if (!this.mergedData['姓名']) return this.$message.error('姓名不一致，请点击选择')
        if (this.mergedData['姓名'] == this.oldData['姓名']) {
          // 删除新数据手机号
          delete this.newData['手机']
        } else {
          // 删除旧数据手机号
          await app.service('radish').modifyById({ _id: this.oldId, data: { 手机: '' } })
        }
        // 新数据存成新人
        const dt = JSON.parse(JSON.stringify(this.newData))
        dt.from = 'searchlist'
        const result = await app.service('radish').insert(dt)
        await app.service('misc').insertBussinessAssistTask({
          type: '新建人选',
          data: { radishId: result.data.id, 姓名: dt.姓名 },
        })
      } else {
        const notHandle = Object.keys(this.mergedData).filter(k => !this.mergedData[k] && this.isDiff(k))
        if (notHandle.length > 0) {
          return this.$message.error('还有未处理的冲突')
        }
        // 改旧数据
        await app.service('radish').modifyById({ _id: this.oldId, data: this.mergedData })
      }
      this.$message.success('合并成功')
      this.onConfirm(this.oldId)
      this.close()
    },
  },
}
</script>
<style>
.a-table > tr > .diffitem {
  border-left: 1px solid #f00;
  border-right: 1px solid #f00;
  border-bottom: 1px solid #f00;
  cursor: pointer;
}
.a-table > tr > .diffitem:hover {
  background-color: #eee;
}
.a-table > tr > th.diffitem {
  border-top: 1px solid #f00;
}
</style>
